export default {"src":"https://s.sylndr.com/c-3732c05/_next/static/media/fullScreenIcon.6502a4eb.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};